import "bootstrap";
import "slick-carousel";
import "readmore-js";
import "./froogaloop2.min";
import "./woocommerce";

(function ($) {
  // On Dom Ready
  $(function () {
    // Toggle Mobile Menu
    $(".menu-open").on("click", function (e) {
      e.preventDefault();
      $(".menu-open").toggleClass("is-active");
      $(".mobile-menu-wrapper").toggleClass("active");
      $("body").toggleClass("noscroll");
    });

    $(".header__main-menu ul li.has-megamenu").hover(
      function () {
        $(this).addClass("active");
        if ($(this).hasClass("sixth-form")) {
          $(".mega-menu.sixth-form").addClass("active");
        }
      },
      function () {
        $(this).removeClass("active");
        $(".mega-menu").removeClass("active");
      }
    );

    $(".mega-menu .container").on({
      mouseenter: function () {
        $(this).parent().addClass("active");
        // $("body").addClass("noscroll");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").addClass("active");
        }
      },
      mouseleave: function () {
        $(this).parent().removeClass("active");
        // $("body").removeClass("noscroll");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").removeClass("active");
        }
      },
    });

    // Home banner Carousel
    $(".home-banner-carousel .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
      fade: true,
    });

    // Toggle footer widgets
    if (window.innerWidth <= 767) {
      $(".footer__title.no-mb").on("click", function (e) {
        e.preventDefault();
        $(this).next().slideToggle();
      });
    } else {
      $(".footer__title.no-mb").slideDown();
    }
  });
})(jQuery);
